import React, {Component} from "react";
import {
    FlatList,
    ActivityIndicator,
    Platform,
    KeyboardAvoidingView,
    TouchableOpacity,
    Alert,
    BackHandler,
    I18nManager,
    View,
    StyleSheet,
    ScrollView
} from "react-native";
// import {
//     PDFViewer,
//     Document,
//     Page,
//     Text,
//     View,
//     StyleSheet,
//     Font,
//
//
// } from '@react-pdf/renderer';

import {typeExport} from "../../../../redux/store/type";
import store, {changeShowInstallPwa} from "../../../../redux/store";
import HMTextView from "../../../../customviews/HMTextView";
import {moderateScale} from "../../../../tools/Scaling";
import Colors from "../../../../tools/Colors";
import i18n from "../../../../I18n/i18n";
import axios from "axios";
import Toast from "../../../../customviews/toast";
import {ToggleSwitch} from "../../../../customviews/switch";
import HMButtonPrint from "../../../../customviews/bottonPrint/HMButtonPrint";
//import _G from "../../../../tools/constant/_G";
// Register Font
// Create styles
// Font.register({
//     family: 'IRANSansMobile',
//     src: 'https://passenger-pwa-cdn.snapp.ir/fonts/Iran-sans-en/en-Iran-sans-web-light.ttf',
// })
//navigator.userAgentData?.mobile
let container = null;
export default class FactorServiceHistorySatiaScreen extends Component {
    constructor(props) {
        super(props);
        store.dispatch(changeShowInstallPwa(true));

        let viewportWidth = 1;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 800 ? 2 : 1;

        }


        this.state = {


            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
            isLoading: false,
            NoInternetDialog: false,
            list: [],
            visibleButtonPrint: true
        };
        container = this;

        // Font.register({
        //     family: 'Roboto',
        //     src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf',
        // })
        this.ConnectServer()
    }


    componentWillReceiveProps(propss) {


    }

    async componentDidMount() {
        if (Platform.OS === "web") {

            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 800 ? 2 : 1,
                    },
                )


            })
        }

    }

    ConnectServer(type) {
        let {item, serial, token, print} = this.props.route.params

        this.setState({
            result: null,
            list: [],
            //ShowImage:true
            isLoading: true,
            NoInternetDialog: false,

        })

        let url = typeExport._baseUrlSatia + "services/serviceHistoryBySerial";

        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('platform', Platform.OS);
        formData.append('serial', item ? item.RegRef : serial);
        formData.append('token', token ? token : store.getState().reducerSplashSatiaScreen.token);

        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                // "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT_FILE
            }
        };

        axios({
            method: 'post',
            url: url,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;
                let message = data.message;

                let list = []
                if (data.status) {
                    let item = data.service;
                    list = [

                        {
                            title: item.Name,
                            description: item.Price,
                            cammas: true
                        },


                        {
                            title: 'هزینه راه اندازی مخابرات',
                            description: item.ranjecost,
                            cammas: true
                        },
                        {
                            title: 'هزینه نصب و کانفیگ در محل',
                            description: item.nasbcost,
                            cammas: true
                        },
                        {
                            title: 'ماليات بر ارزش افزوده',
                            description: item.Tax,
                            cammas: true
                        },
                        {
                            title: 'آبونمان',
                            description: item.Subscription,
                            cammas: true
                        },
                        {
                            //title: 'آبونمان ویژه',
                            title: item.NameAbonmanSpecial,
                            description: item.AbonmanSpecial,
                            cammas: true
                        },
                        {
                            title: 'هزینه ارسال پیامک',
                            description: item.SmsCost,
                            cammas: true
                        },

                        {
                            title: 'تخفیف',
                            description: item.Discount,
                            cammas: true,
                            //type: 'totalPrice'
                        },


                    ];

                    let items = []
                    for (let i = 0; i < list.length; i++) {
                        let item = list[i];
                        if (item.description == 0 || item.description == null || item.description == undefined) {
                        }
                        else
                            items.push(item)
                    }
                    list = items;
                }

                this.setState({
                        //ShowImage:true
                        //list: data.status ? list : this.state.list,
                        //TypeDocumentsList:[],
                        isLoading: false,
                        NoInternetDialog: !data.status,
                        result: data.status ? data : null,
                        list: list

                    },
                    () => {
                        print && Platform.OS === "web" && data.status ? window.print() : null
                    }
                )

                if (!data.status)
                    Toast.show({
                        // type: 'success | error | info',
                        type: data.status ? 'custom_success' : 'custom_error',
                        //  type: data.status ? 'custom_success' : 'custom_error',
                        //  position: 'top | bottom',
                        position: 'top',
                        text1: i18n.t('constant.message'),
                        text2: message,
                        visibilityTime: 4000,
                        autoHide: true,
                        //  topOffset: 30,
                        // bottomOffset: 40,
                        onShow: () => {
                        },
                        onHide: () => {
                        }
                    })


            }).catch((e) => {
            Toast.show({
                // type: 'success | error | info',
                type: 'custom_error',
                //  position: 'top | bottom',
                position: 'top',
                text1: i18n.t('constant.message'),
                text2: "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
                visibilityTime: 4000,
                autoHide: true,
                //  topOffset: 30,
                // bottomOffset: 40,
                onShow: () => {
                },
                onHide: () => {
                }
            })
            /*    HMAlert(
                    i18n.t('constant.message'),
                    "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
                    [
                        {
                            text: i18n.t('constant.ok'), onPress: () => {

                            }


                        },

                    ],
                    {cancelable: true}
                )*/
            this.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,


            })

            console.log('error', e)
        })
    }

    componentWillUnmount() {

    }


    render() {
        // let {item} = this.props.item ? this.props : this.props.route.params;
        let item = this.props.navigation && this.props.route && this.props.route.params ? this.props.route.params.item : this.props.item;
        let checkLogin = (store.getState().reducerSplashSatiaScreen.token)


        let check_ui = Platform.OS === "web" && this.state.viewportWidth > 600;
        let isRTL = I18nManager.isRTL;
        return (
            <View>
                {this.renderPDFViewer()}
            </View>
            //
            //
            // <PDFViewer style={{width: "100%", flexBasis: '100%',}}>

            // </PDFViewer>
            //
            //

        );
    }

    renderPDFViewer() {
        let {Account, unitValue, unit} = store.getState().reducerSplashSatiaScreen;
        unitValue = unitValue ? unitValue : 10;
        unit = unit ? unit : "تومان";
        let {result, isLoading} = this.state;
        let itemExtra = this.props.route.params.item;
        let Discount = result && result.service?.Discount;
        let {serial, token, print} = this.props.route.params

        //  let isRTL = I18nManager.isRTL;
        let isRTL = false;
        return <View style={{width: "100%"}}>
            {
                !isLoading && result ?
                    <ScrollView style={{width: "100%"}}>
                        <View style={{width: "100%"}}>

                            <View
                                style={{width: "100%", marginBottom: moderateScale(8), padding: moderateScale(8)}}>
                                <View style={{width: "100%", flexDirection: "row"}}>

                                    <View style={{flex: .2, flexDirection: "row"}}>
                                        {
                                            !this.state.visibleButtonPrint || serial ?
                                                null
                                                :
                                                <HMButtonPrint serial={itemExtra ? itemExtra.RegRef : serial}
                                                               onPressHidden={() => {
                                                                   this.setState({visibleButtonPrint: false}, () => {
                                                                       Platform.OS === "web" ? window.print() : null
                                                                   })
                                                               }}/>

                                        }
                                    </View>
                                    <View style={{flex: .6}}>
                                        <HMTextView

                                            // numberOfLines={2}
                                            type={"bold"}
                                            text={"فروشگاه اینترنتی"}
                                            style={{
                                                fontSize: moderateScale(18),

                                                color: Colors.colorDarkText,
                                                marginHorizontal: moderateScale(2),
                                                marginBottom: moderateScale(20),
                                                //  textAlign: "right",
                                            }}
                                            styleRoot={{alignSelf: 'center',}}
                                        />
                                    </View>
                                    <View style={{flex: .2}}>

                                    </View>

                                </View>
                                <View
                                    style={{flexDirection: isRTL ? "row-reverse" : "row", width: "100%"}}>
                                    <View
                                        style={{width: "50%"}}>
                                        {this.renderTilteDesc("شماره فاکتور", itemExtra ? itemExtra.RegRef : serial)}
                                    </View>
                                    <View
                                        style={{width: "50%"}}>
                                        {this.renderTilteDesc("تاریخ", result.service.pivot.Date)}
                                    </View>
                                </View>


                                <View
                                    style={{flexDirection: isRTL ? "row-reverse" : "row", width: "100%"}}>
                                    <View
                                        style={{width: "50%"}}>
                                        {this.renderTilteDesc("نام مشترک", result.customer.Name)}
                                    </View>
                                    <View
                                        style={{width: "50%"}}>
                                        {this.renderTilteDesc("شماره تلفن", result.customer.AdslTel)}
                                    </View>
                                </View>


                                <View
                                    style={{flexDirection: isRTL ? "row-reverse" : "row", width: "100%"}}>
                                    <View
                                        style={{width: "50%"}}>
                                        {this.renderTilteDesc("تلفن همراه", result.customer.Mobile)}
                                    </View>
                                    <View
                                        style={{width: "50%"}}>
                                        {this.renderTilteDesc("پست الکترونيک", result.customer.Email)}
                                    </View>
                                </View>


                                <View
                                    style={{flexDirection: isRTL ? "row-reverse" : "row", width: "100%"}}>

                                    {this.renderTilteDesc("آدرس", result.customer.detail.Address)}


                                </View>


                            </View>

                            <View
                                style={{
                                    flexDirection: "row",
                                    width: "100%",
                                    backgroundColor: "#c8c8c8",
                                    justifyContent: "center",
                                    paddingVertical: moderateScale(6),
                                    borderTopColor: Colors.blackLight,
                                    borderTopWidth: moderateScale(1),
                                }}>
                                <View style={{width: "10%"}}>
                                    <HMTextView

                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={"ردیف"}
                                        style={{
                                            fontSize: moderateScale(14),

                                            color: Colors.colorDarkText,

                                            //  textAlign: "right",
                                        }}
                                        styleRoot={{paddingStart: moderateScale(4)}}
                                    />
                                </View>
                                <View style={{width: "65%",}}>
                                    <HMTextView

                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={"شرح"}
                                        style={{
                                            fontSize: moderateScale(14),

                                            color: Colors.colorDarkText,
                                            //  textAlign: "right",
                                        }}
                                        styleRoot={{}}
                                    />
                                </View>
                                <View style={{width: "25%",}}>
                                    <HMTextView

                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={"مبلغ (تومان)"}
                                        style={{
                                            fontSize: moderateScale(14),

                                            color: Colors.colorDarkText,
                                            //  textAlign: "right",
                                        }}
                                        styleRoot={{}}
                                    />
                                </View>
                            </View>


                            <View
                                style={{
                                    borderRadius: moderateScale(4),
                                    borderColor: '#d0d8df',
                                    backgroundColor: Colors.white,
                                    borderWidth: moderateScale(1),
                                    overflow: 'hidden',
                                    marginTop: moderateScale(6),
                                    marginHorizontal: moderateScale(4),
                                }}>
                                <FlatList
                                    style={{}}
                                    // ItemSeparatorComponent={
                                    //     <View style={{
                                    //         width: '100%',
                                    //         height: moderateScale(1),
                                    //         backgroundColor: '#4f4f4f'
                                    //     }}/>
                                    // }
                                    // data={comment === null || !comment ? [] : comment}
                                    //     numColumns={1}
                                    //type => 1=  , 2= , 3= , 4= ,
                                    data={this.state.list}
                                    renderItem={({item, index}) => {
                                        let resultPrice = parseInt((item.description - (this.state.isOnBlueToggleSwitch && item.type == "totalPrice" ? this.state.wallet : 0)) / unitValue)
                                        return <View
                                            style={[{
                                                flex: 1,
                                                flexWrap: 'wrap',
                                                flexDirection: 'row',


                                                backgroundColor: index % 2 === 0 ? Colors.light : Colors.white,
                                                //  padding: moderateScale(4),
                                                paddingVertical: moderateScale(8)
                                            }]}>


                                            <View
                                                style={{
                                                    flexDirection: "row",
                                                    width: "100%",
                                                    justifyContent: "center",
                                                }}>
                                                <View style={{width: "10%"}}>
                                                    <HMTextView

                                                        // numberOfLines={2}
                                                        type={"bold"}
                                                        text={index + 1}
                                                        style={{
                                                            fontSize: moderateScale(14),

                                                            color: Colors.colorDarkText,

                                                            //  textAlign: "right",
                                                        }}
                                                        styleRoot={{paddingStart: moderateScale(4)}}
                                                    />
                                                </View>
                                                <View style={{width: "65%",}}>
                                                    <HMTextView type={"bold"} text={item.title} style={{
                                                        color: Colors.blackLight,
                                                        fontSize: moderateScale(12),
                                                        marginEnd: moderateScale(4)
                                                    }}/>
                                                </View>
                                                <View style={{width: "25%",}}>
                                                    {
                                                        // index == 2 ?
                                                        //     <View style={{flexDirection: 'row'}}>
                                                        //         <HMTextView
                                                        //             // numberOfLines={2}
                                                        //             //type={"bold"}
                                                        //             cammas={item.cammas}
                                                        //             text={(parseInt((item.description / unitValue)) + " " + unit)}
                                                        //             style={[{
                                                        //                 fontSize: moderateScale(14),
                                                        //
                                                        //                 color: Colors.blackLight,
                                                        //                 marginHorizontal: moderateScale(2),
                                                        //                 //  marginTop: moderateScale(4),
                                                        //                 //  textAlign: "right",
                                                        //
                                                        //
                                                        //             },]}/>
                                                        //
                                                        //     </View>
                                                        //     :
                                                        <View style={{
                                                            flex: 1,
                                                            flexWrap: 'wrap',
                                                            // flexDirection: 'row',

                                                            backgroundColor: index % 2 === 0 ? Colors.light : Colors.white,
                                                            //   padding: moderateScale(4),
                                                            // paddingVertical:moderateScale(8),

                                                        }}>
                                                            <HMTextView cammas={item.cammas} type={"bold"}
                                                                        text={(item.description && item.cammas) || item.description == 0 ? (resultPrice <= 0 ? 0 : resultPrice) : item.description ? item.description : " - "}
                                                                //  text={(item.description && item.cammas) || item.description == 0 ? (resultPrice <= 0 ? 0 : resultPrice) + (item.cammas ? " " + unit : "") : item.description ? item.description : " - "}
                                                                        style={{
                                                                            color: Colors.blackLight,
                                                                            fontSize: moderateScale(14),
                                                                            //marginEnd: moderateScale(10)
                                                                        }}/>
                                                        </View>
                                                    }

                                                    {
                                                        item.type === "wallet" && false ?
                                                            <ToggleSwitch
                                                                label="استفاده از اعتبار"
                                                                onColor={"rgb(0, 96, 96)"}
                                                                isOn={this.state.isOnBlueToggleSwitch}
                                                                onToggle={isOnBlueToggleSwitch => {
                                                                    this.setState({isOnBlueToggleSwitch});
                                                                }}
                                                            />
                                                            :
                                                            null
                                                    }
                                                </View>
                                            </View>


                                        </View>

                                    }}


                                />
                            </View>
                            <View
                                style={{
                                    flexDirection: "row",
                                    width: "100%",
                                    backgroundColor: "#c8c8c8",
                                    justifyContent: "center",
                                    paddingVertical: moderateScale(6),
                                    borderTopColor: Colors.blackLight,
                                    borderTopWidth: moderateScale(1),
                                }}>
                                <View style={{width: "40%"}}>
                                    <HMTextView

                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={"جمع کل فاکتور"}
                                        style={{
                                            fontSize: moderateScale(14),

                                            color: Colors.colorDarkText,

                                            //  textAlign: "right",
                                        }}
                                        styleRoot={{paddingStart: moderateScale(4)}}
                                    />
                                </View>
                                <View style={{width: "35%",}}>
                                    <HMTextView

                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={""}
                                        style={{
                                            fontSize: moderateScale(14),

                                            color: Colors.colorDarkText,
                                            //  textAlign: "right",
                                        }}
                                        styleRoot={{}}
                                    />
                                </View>
                                <View style={{width: "25%",}}>
                                    <HMTextView
                                        cammas
                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={result.service.SumPrice / unitValue}
                                        style={{
                                            fontSize: moderateScale(14),

                                            color: Colors.colorDarkText,
                                            //  textAlign: "right",
                                        }}
                                        styleRoot={{}}
                                    />
                                </View>
                            </View>
                            <View
                                style={{
                                    flexDirection: "row",
                                    width: "100%",
                                    //   backgroundColor: "#c8c8c8",
                                    justifyContent: "center",
                                    paddingVertical: moderateScale(6),
                                    borderTopColor: Colors.blackLight,
                                    borderTopWidth: moderateScale(1),
                                }}>
                                <View style={{width: "30%"}}>
                                    <HMTextView

                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={""}
                                        style={{
                                            fontSize: moderateScale(14),

                                            color: Colors.colorDarkText,

                                            //  textAlign: "right",
                                        }}
                                        styleRoot={{paddingStart: moderateScale(4)}}
                                    />
                                </View>
                                <View style={{width: "25%",}}>
                                    <HMTextView

                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={""}
                                        style={{
                                            fontSize: moderateScale(14),

                                            color: Colors.colorDarkText,
                                            //  textAlign: "right",
                                        }}
                                        styleRoot={{}}
                                    />
                                </View>
                                <View style={{width: "45%", marginVertical: moderateScale(40)}}>
                                    <HMTextView
                                        cammas
                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={"مهر و امضا شرکت"}
                                        style={{
                                            fontSize: moderateScale(14),

                                            color: Colors.colorDarkText,
                                            //  textAlign: "right",
                                        }}
                                        styleRoot={{}}
                                    />
                                </View>
                            </View>

                        </View>
                    </ScrollView>
                    :
                    <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>

            }

        </View>

    }

    /*
        renderPDFViewer() {

            //  let isRTL = I18nManager.isRTL;
            let isRTL = false;
            return <Document style={{width: "100%", flexBasis: '100%',}}>
                <Page size="A4" style={styles.page}>
                    <View style={{width: "100%"}}>
                        <View
                            style={{width: "100%"}}>
                            <Text style={{
                                alignSelf: 'center',
                                marginBottom: moderateScale(10)
                            }}>{"فروشگاه اینترنتی"}</Text>

                            <View
                                style={{flexDirection: isRTL ? "row-reverse" : "row", width: "100%"}}>
                                <View
                                    style={{width: "50%"}}>
                                    {this.renderTilteDesc("شماره فاکتور", "90807")}
                                </View>
                                <View
                                    style={{width: "50%"}}>
                                    {this.renderTilteDesc("تاریخ", "90807")}
                                </View>
                            </View>


                            <View
                                style={{flexDirection: isRTL ? "row-reverse" : "row", width: "100%"}}>
                                <View
                                    style={{width: "50%"}}>
                                    {this.renderTilteDesc("نام مشترک", "90807")}
                                </View>
                                <View
                                    style={{width: "50%"}}>
                                    {this.renderTilteDesc("شماره تلفن", "90807")}
                                </View>
                            </View>


                            <View
                                style={{flexDirection: isRTL ? "row-reverse" : "row", width: "100%"}}>
                                <View
                                    style={{width: "50%"}}>
                                    {this.renderTilteDesc("تلفن همراه", "90807")}
                                </View>
                                <View
                                    style={{width: "50%"}}>
                                    {this.renderTilteDesc("پست الکترونيک", "90807")}
                                </View>
                            </View>


                            <View
                                style={{flexDirection: isRTL ? "row-reverse" : "row", width: "100%"}}>

                                {this.renderTilteDesc("آدرس", "90807")}


                            </View>

                            <View style={{width: '100%', height: moderateScale(1), backgroundColor: "#0b0b0b"}}/>


                        </View>

                        <View
                            style={{width: "100%", height: moderateScale(200)}}>

                        </View>
                    </View>
                </Page>
            </Document>

        }
    */

    // renderTilteDesc(title, description) {
    //     let isRTL = I18nManager.isRTL;
    //
    //     return <View
    //         style={{
    //             flexDirection: isRTL ? "row-reverse" : "row",
    //             width: "100%",
    //             marginVertical: moderateScale(2),
    //             paddingHorizontal: moderateScale(6)
    //         }}>
    //         <Text style={{alignSelf: 'center', fontSize: moderateScale(14)}}>{title + " : "}</Text>
    //         <View style={{width: moderateScale(10)}}/>
    //         <Text style={{alignSelf: 'center', fontSize: moderateScale(14)}}>{description}</Text>
    //
    //
    //     </View>
    // }
    renderTilteDesc(title, description) {
        //let isRTL = I18nManager.isRTL;
        let isRTL = false;

        return <View
            style={{
                flexDirection: isRTL ? "row-reverse" : "row",
                flex: 1,
                flexWrap: 'wrap',
                marginVertical: moderateScale(2),
                paddingHorizontal: moderateScale(6)
            }}>
            <HMTextView
                // cammas
                // numberOfLines={2}
                type={"bold"}
                text={title + " : "}
                style={{
                    fontSize: moderateScale(13),

                    color: Colors.colorDarkText,
                    marginHorizontal: moderateScale(2),
                    //  marginTop: moderateScale(4),
                    //  textAlign: "right",
                }}/>
            <View style={{width: moderateScale(2)}}/>
            <HMTextView
                //cammas
                // numberOfLines={2}
                //  type={"bold"}
                text={description}
                style={{
                    fontSize: moderateScale(14),

                    color: Colors.colorDarkText,
                    marginHorizontal: moderateScale(2),

                    //  marginTop: moderateScale(4),
                    //  textAlign: "right",
                }}
                styleRoot={{
                    // flexDirection: 'column',
                    flex: 1,
                    // justifyContent: "flex-end",
                    flexWrap: 'wrap',
                    // alignItems: 'center', justifyContent: 'center'
                }}
            />
        </View>
    }

}

const styles = StyleSheet.create({
    page: {
        //     fontFamily: typeExport.regularFontName,
        // fontFamily: 'IRANSansMobile',
        // flexDirection: 'rtl',
        //  height: 500,
        //   flexDirection: 'row',
        backgroundColor: '#E4E4E4'
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    }
});
